export default __webpack_public_path__ + "static/media/twoBottomRight.d2decc99.svg";